export  enum  MemberType  {
    DISTRIBUTOR  =  5,
    RETAILCUSTOMER  =  6,
    GUESTCUSTOMER = 93,
    PREFERREDCUSTOMER = 99
}

export enum MemberTitle {
    FPC = 'Forever Preferred Customer',
    RETAIL = 'Retail'
}
